import { Component, OnInit } from '@angular/core';
import { faTimes, faChevronRight } from '@fortawesome/pro-light-svg-icons';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { ExtraServiceVisaComponent } from '../extra-service-visa/extra-service-visa.component';
import { ExtraServiceCarComponent } from '../extra-service-car/extra-service-car.component';
import { ExtraServiceAirportComponent } from '../extra-service-airport/extra-service-airport.component';
import { ExtraServiceTravelComponent } from '../extra-service-travel/extra-service-travel.component';
import { ExtraServiceRentalComponent } from '../extra-service-rental/extra-service-rental.component';
import { ExtraServiceFlightComponent } from '../extra-service-flight/extra-service-flight.component';
import { ExtraServiceRemovalComponent } from '../extra-service-removal/extra-service-removal.component';

@Component({
  selector: 'app-extra-service-modal',
  templateUrl: './extra-service-modal.component.html',
  styleUrls: ['./extra-service-modal.component.scss']
})
export class ExtraServiceModalComponent implements OnInit {
  icons = {
    cancel: faTimes,
    chevronRight: faChevronRight
  }
  constructor(
    public bsModalRef: BsModalRef,
    private modalService: BsModalService,
    public options: ModalOptions
  ) { }

  ngOnInit(): void {

  }

  requestFlight() {
    this.bsModalRef?.hide()
    const initialState = { edit: true, person: this.options?.initialState?.person, booking: this.options?.initialState?.booking, user:  this.options?.initialState?.user}

    const options: any = {initialState, class: 'modal-rounded' }

    this.bsModalRef?.hide()
    this.bsModalRef =  this.modalService.show(ExtraServiceFlightComponent, options)
  }

  requestRental() {
    this.bsModalRef?.hide()
    const initialState = { edit: true, person: this.options?.initialState?.person, booking: this.options?.initialState?.booking, user:  this.options?.initialState?.user}

    const options: any = {initialState, class: 'modal-rounded' }

    this.bsModalRef =  this.modalService.show(ExtraServiceRentalComponent, options)
  }

  requestTravel() {
    this.bsModalRef?.hide()
    const initialState = { edit: true, person: this.options?.initialState?.person, booking: this.options?.initialState?.booking, user:  this.options?.initialState?.user}

    const options: any = {initialState, class: 'modal-rounded' }
    this.bsModalRef =  this.modalService.show(ExtraServiceTravelComponent, options)


  }

  requestAirport() {
    this.bsModalRef?.hide()
    const initialState = { edit: true, person: this.options?.initialState?.person, booking: this.options?.initialState?.booking, user:  this.options?.initialState?.user}

    const options: any = {initialState, class: 'modal-rounded' }

    this.bsModalRef =  this.modalService.show(ExtraServiceAirportComponent, options)
  }

  requestCar() {
    this.bsModalRef?.hide()
    const initialState = { edit: true, person: this.options?.initialState?.person, booking: this.options?.initialState?.booking, user:  this.options?.initialState?.user}

    const options: any = {initialState, class: 'modal-rounded' }
    this.bsModalRef =  this.modalService.show(ExtraServiceCarComponent, options)


  }

  requestVisa() {
    this.bsModalRef?.hide()
    const initialState = { edit: true, person: this.options?.initialState?.person, booking: this.options?.initialState?.booking, user:  this.options?.initialState?.user}

    const options: any = {initialState, class: 'modal-rounded' }

    this.bsModalRef =  this.modalService.show(ExtraServiceVisaComponent, options)
  }

  requestRemoval() {
    this.bsModalRef?.hide()
    const initialState = { edit: true, person: this.options?.initialState?.person, booking: this.options?.initialState?.booking, user:  this.options?.initialState?.user}

    const options: any = {initialState, class: 'modal-rounded' }

    this.bsModalRef =  this.modalService.show(ExtraServiceRemovalComponent, options)
  }

}
